module.exports = __webpack_public_path__ + "static/media/pipes-app_2screen.18dbddb2.png";